export enum CSVErrors {
  MAX_ROWS_EXCEEDED = "MAX_ROWS_EXCEEDED", // Max rows limit is 1000
  INVALID_TYPE = "INVALID_TYPE", // The file is not a csv
  EMAIL_ERRORS = "EMAIL_ERRORS", // We have some rows not correctly parsed
  SELF_REWARD = "SELF_REWARD", // Admins can't reward themself
  MULTIPLE_COLUMNS = "MULTIPLE_COLUMNS" // The csv has multiple columns
}
export const CSVErrorsMessages = {
  [CSVErrors.MAX_ROWS_EXCEEDED]: "wallet.adminReward.bulkRewards.errors.exceedsRows",
  [CSVErrors.INVALID_TYPE]: "wallet.adminReward.bulkRewards.errors.wrongFileType",
  [CSVErrors.SELF_REWARD]: "wallet.adminReward.bulkRewards.errors.selfReward",
  [CSVErrors.MULTIPLE_COLUMNS]: "wallet.adminReward.bulkRewards.errors.incorrectFormat"
}
